import moment from "moment";
import "moment/locale/es";

moment.locale("es");

const verFormasPdf = (values) => {
    const empresa = values.empresa;
    const formas = values.formas;
    const insumo = values.insumo;
    const logoBiwo = values.logoBiwo;
    const conceptos = formas.flatMap((valueConcepto) => {
        // Obtener todas las imágenes base64 de todos los lotes del insumo
        const imagenesBase64 = []
        if (valueConcepto.imagenes && Array.isArray(valueConcepto.imagenes) && valueConcepto.imagenes.length > 0) {
            valueConcepto.imagenes.forEach((imagen) => {
                if (imagen.base64Completa) {
                    imagenesBase64.push(imagen.base64Completa);
                }
            });
        }

        const filaInsumo = [
            { text: valueConcepto.clave, style: 'textoTabla', alignment: 'left' },
            { text: valueConcepto.descripcionForma, style: 'textoTabla', alignment: 'center' },
        ];

        const filaImagenes = [
            {
                colSpan: 2,
                alignment: 'center',
                border: [true, false, true, true],
                columns: imagenesBase64.length > 0 ? imagenesBase64.map(img => ({
                    image: img,
                    fit: [160, 160],
                    margin: [5, 5, 5, 5]
                })) : [{ text: 'Sin imágenes', style: 'textoTabla', alignment: 'center' }]
            },
            {}, // colSpan relleno 2
        ];

        return [filaInsumo, filaImagenes];
    });
    var dd = {
        footer: {
            image: 'logoBiwo', alignment: 'center', width: 80
        },
        content: [
            {
                style: 'tableExample',
                table: {
                    widths: ['18%', '52%', '30%'],
                    layout: {
                        defaultBorder: false,
                    },
                    body: [
                        [
                            {
                                //							rowSpan: 3,
                                border: [false, false, false, false],
                                image: 'logo',
                                fit: [80, 80]
                                //text: 'rowSpan: 3\n\nborder:\n[true, true, true, true]'
                            },
                            {
                                //	rowSpan: 2,
                                border: [false, false, false, false],
                                table: {
                                    headerRows: 1,
                                    widths: ['100%'],

                                    body: [
                                        [
                                            {
                                                text: empresa.nombreComercial ? empresa.nombreComercial : (empresa.persona ? empresa.nombre : empresa.nombre + ' ' + empresa.apellidoPaterno + ' ' + empresa.apellidoMaterno),
                                                style: "tableHeader"
                                            }
                                        ],
                                        [
                                            {
                                                text: "R.F.C: " + empresa.rfc,
                                                style: "textoChico",
                                                alignment: "center",
                                            },
                                        ],
                                        [
                                            {
                                                text: empresa.calle + ' ' +
                                                    empresa.numeroCalle + ' ' +
                                                    (empresa.numeroInterior ? empresa.numeroInterior : '')
                                                ,
                                                style: "textoChico",
                                                alignment: "center",
                                            },
                                        ],
                                        [
                                            {
                                                text: empresa.colonia.tipoAsentamiento + ' ' +
                                                    empresa.colonia.nombre + ' C.P. ' +
                                                    empresa.colonia.cp + ' ' +
                                                    empresa.municipio.nombre + ' ' +
                                                    empresa.estado.abreviatura + ' ' +
                                                    empresa.pais.abreviatura + ' '
                                                ,
                                                style: "textoChico",
                                                alignment: "center",
                                            },
                                        ],
                                        [{ text: 'FORMAS ' + insumo.descripcion, style: 'tableHeader' }],
                                    ]
                                },
                                layout: 'noBorders'
                            },
                            {
                                border: [false, false, false, false],
                                table: {
                                    headerRows: 1,
                                    widths: ['100%'],

                                    body: [
                                        [{ text: 'Fecha Impresion:', style: 'subheader', alignment: 'center' }],
                                        [{ text: moment().locale('es').format('LL'), style: 'textoChico', alignment: 'center' }],
                                    ]
                                },
                                layout: 'noBorders'
                            },
                        ]

                    ]
                },
            },

            {
                style: 'tableExample',
                table: {
                    widths: ['20%', '80%'],
                    layout: {
                        defaultBorder: true,
                    },
                    body: [
                        [
                            { text: 'Clave', style: 'tituloTabla' },
                            { text: 'Descripción', style: 'tituloTabla' },
                        ],
                        ...conceptos
                    ]
                },
                layout: {
                    fillColor: (rowIndex, node, columnIndex) => {
                        return rowIndex % 2 === 0 ? "#e8e8e8" : "#ffffff";
                    },
                    hLineWidth: function (i, node) {
                        return (i === 0 || i === node.table.body.length) ? 1 : 1;
                    },
                    vLineWidth: function (i, node) {
                        return (i === 0 || i === node.table.widths.length) ? 1 : 1;
                    },
                    hLineColor: function (i, node) {
                        return '#adaaaa';
                    },
                    vLineColor: function (i, node) {
                        return '#adaaaa';
                    },
                    hLineStyle: function (i, node) {
                        if (i === 0 || i === node.table.body.length) {
                            return null;
                        }
                        return { dash: { length: 2, space: 1 } };
                    },
                    vLineStyle: function (i, node) {
                        if (i === 0 || i === node.table.widths.length) {
                            return null;
                        }
                        return { dash: { length: 2 } };
                    },
                }
            },
        ],
        images: {
            logo: empresa.logo.base64Completa,
            logoBiwo: logoBiwo.base64Completa,
        },
        styles: {
            header: {
                fontSize: 9,
                bold: true,
            },
            subheader: {
                fontSize: 8,
                bold: true,
            },
            tableExample: {
                margin: [0, 5, 0, 5]
            },
            tablaSinMargen: {
                margin: [0, 0, 0, 0]
            },
            tableHeader: {
                bold: true,
                fontSize: 12,
                color: 'black',
                alignment: 'center'
            },
            textoChico: {
                fontSize: 8
            },
            tituloTabla: {
                fontSize: 8,
                bold: true,
                fillColor: '#cccccc',
                style: 'subheader',
                alignment: 'center',
                border: true
            },
            textoTabla: {
                fontSize: 8,
                italics: false
            }
        },
        pageSize: 'LETTER',
        pageMargins: [20, 20, 20, 60],
    }
    return dd;
};

export default verFormasPdf;